import React, { useState, useMemo } from 'react';
import { Typography, Box, Grid } from '@mui/material';
import CustomTable from 'src/ui-component/CustomTable/Index';
import CustomSearchBar from 'src/ui-component/CustomSearchBar';

interface UpdatedFee {
  Yearly: string;
  Monthly: string;
}
export interface Service {
  Yearly: string;
  Monthly: string;
  ChangeReason: string;
  UpdatedBy: string;
  UpdateDate: string;
  UpdatedFee: UpdatedFee;
}
interface Props {
  services: Service[];
}

const ServiceHistory: React.FC<Props> = ({ services }) => {
  const [pagination, setPagination] = useState(1);
  const [isSearch, setIsSearch] = useState('');
  const [searchVal, setSearchVal] = useState('');
  const [filteredRows, setFilteredRows] = useState<any[]>([]);

  const columns = [
    'Last Updated Fee (Yearly) ',
    'Last Updated Fee (Monthly) ',
    'Reason for Fee Change',
    'Updated By',
    'Updated Date'
  ];

  // Transform services data for the table
  const rows = useMemo(() => {
    return services.map((service) => [
      `$${service?.UpdatedFee?.Yearly}`,
      `$${service?.UpdatedFee?.Monthly}`,
      service.ChangeReason,
      service.UpdatedBy,

      service.UpdateDate
        ? new Date(service.UpdateDate).toLocaleDateString('en-US')
        : ''
    ]);
  }, [services]);

  if (services.length === 0) {
    return <Typography>No Fee History Available</Typography>;
  }

  return (
    <>
      <Typography variant="h6" gutterBottom p={1}>
        Fee History
      </Typography>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item md={3} lg={3} xl={2} xs={12} sm={12}>
          <CustomSearchBar
            rows={rows}
            setFilteredRows={setFilteredRows}
            setpagination={setPagination}
            setIsSearch={setIsSearch}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 3 }}>
        <CustomTable
          pagination={pagination}
          setSelectedRowData={() => {}}
          rows={filteredRows.length > 0 ? filteredRows : rows}
          columns={columns}
          isSearch={isSearch}
        />
      </Box>
    </>
  );
};

export default ServiceHistory;
